export default __webpack_public_path__ + "static/636a8943c2e245e98d8b064a032ac9cb.webp";